module.exports = __webpack_public_path__ + "daisy_small.7cfa0d4.jpg";